import { render, staticRenderFns } from "./sendBox.vue?vue&type=template&id=2744fb11&scoped=true&"
import script from "./sendBox.vue?vue&type=script&lang=js&"
export * from "./sendBox.vue?vue&type=script&lang=js&"
import style0 from "./sendBox.vue?vue&type=style&index=0&id=2744fb11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2744fb11",
  null
  
)

export default component.exports